__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@creleads/host-ui-service";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@jpmuitk/column-layout", "32.1.2", () => (() => (__webpack_require__(4228))), 1);
			register("@jpmuitk/link", "32.1.2", () => (() => (__webpack_require__(4869))), 1);
			register("@jpmuitk/style", "32.1.2", () => (() => (__webpack_require__(3456))), 1);
			register("@jpmuitk/theme", "32.1.2", () => (() => (__webpack_require__(3259))), 1);
			register("@material-ui/core/CssBaseline", "4.10.2", () => (() => (__webpack_require__(8002))), 1);
			register("@material-ui/core/Grid", "4.10.2", () => (() => (__webpack_require__(5573))), 1);
			register("@material-ui/core/styles", "4.10.2", () => (() => (__webpack_require__(8346))), 1);
			register("@material-ui/styles", "4.11.5", () => (() => (__webpack_require__(6353))), 1);
			register("@octagon/public-analytics-dps-service", "1.0.1", () => (() => (__webpack_require__(9094))), 1);
			register("@octagon/public-analytics", "3.0.1", () => (() => (__webpack_require__(6707))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-error-boundary", "4.1.2", () => (__webpack_require__.e(665).then(() => (() => (__webpack_require__(7665))))));
			register("react-location-rank-routes", "3.2.15", () => (Promise.all([__webpack_require__.e(980), __webpack_require__.e(215)]).then(() => (() => (__webpack_require__(8215))))));
			register("react-location", "3.2.15", () => (() => (__webpack_require__(5489))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			initExternal(8147);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};